"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = store;
var _store = require("./dashboard/store.dashboard");
var _store2 = require("./tenant/store.tenant");
function store() {
  var appStore;
  if (process.env.REACT_APP_CLIENT == "dashboard") {
    appStore = _store.dashboardStore;
  } else if (process.env.REACT_APP_CLIENT == "tenant") {
    appStore = _store2.tenantStore;
  }
  return appStore();
}